import queryString from 'query-string';
import { changeClassRoom } from '../../../core/actions/classRoom';
import * as selectors from '../../../core/selectors/spaces';
import push from '../../utils/routing';
import { isHomePageLandingEnabled } from '../../utils/homeLanding';

const AllowedQueryParams = new Set(['inbox', 'tagId', 'user-profile']);
const filterQuery = (query) =>
  Object.keys(query).reduce(
    (acc, key) =>
      AllowedQueryParams.has(key) ? { ...acc, [key]: query[key] } : acc,
    {}
  );

export default (spaceId, searchQuery, fetchFeatureFlags, ldClient) =>
  async (dispatch, getState) => {
    const state = getState();
    const currentSpaceId = selectors.current(selectors.space(state));
    const filteredQuery = filterQuery(queryString.parse(searchQuery));
    const { tagId } = filteredQuery;
    const desiredSpaceId =
      spaceId || currentSpaceId || selectors.initialSpaceId(state);

    if (!desiredSpaceId) {
      push({
        pathname: '/nospaces',
        query: filteredQuery,
      });
      return;
    }
    const report = false; // Don't send CHANGE_CLASSROOM event on startup
    const reset = false;
    if (typeof spaceId === 'undefined') {
      if (isHomePageLandingEnabled(ldClient)) {
        push({
          pathname: '/home',
          query: filteredQuery,
        });
        return;
      }
      push({
        pathname: `/dashboard/${desiredSpaceId}`,
        query: filteredQuery,
      });
    } else if (spaceId === 'undefined') {
      // for cases where the user has no spaces but reloads the app from a URL with /dashboard/undefined/
      fetchFeatureFlags(undefined);
    } else {
      await dispatch(
        changeClassRoom(desiredSpaceId, report, reset, tagId, fetchFeatureFlags)
      );
    }
  };
